import canUseDOM from './canUseDOM'

export const getServerSideURL = () => {
  return process.env.NEXT_PUBLIC_SERVER_URL || 'http://localhost:3000'
}

export const getClientSideURL = () => {
  if (canUseDOM) {
    const protocol = window.location.protocol
    const domain = window.location.hostname
    const port = window.location.port

    return `${protocol}//${domain}${port ? `:${port}` : ''}`
  }

  // SSR/RSC: nunca retornar string vazia (evita fetch relativo/inválido → "Failed to fetch").
  return getServerSideURL()
}
